export const IMAGE_WIDTH = 200;
export const CONTAINER_GAP = 10;

export const REQUIRED_FIELDS_FOR_SUGGEST_IMAGE_PROMPT: Record<string, string[]> = {
  persona: ["name", "highlights"],
  character: ["name", "title"],
};
